//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

  name: 'CourseCard',

  props: {
    course: {
      type: Object,
      default: () => {}
    }
  },

  filters: {
    money: function (n, c, d, t) {
      var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }
  },

  methods: {

    openCourseDetail(course) {
      this.$router.push({ name: 'academy.course.detail', params: { id: course.id, slug: course.slug } })
    },

    courseUrl(course) {
      const { href } = this.$router.resolve({ name: 'academy.course.detail', params: { id: course.id, slug: course.slug } })
      return href
    },

  }

}

